/**
 * @generated SignedSource<<511f6ea0d0fe996120f55c9b3f75c25b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type TradeEOYMessaging_profile$data = {
  readonly currency: Currency | null;
  readonly " $fragmentType": "TradeEOYMessaging_profile";
};
export type TradeEOYMessaging_profile$key = {
  readonly " $data"?: TradeEOYMessaging_profile$data;
  readonly " $fragmentSpreads": FragmentRefs<"TradeEOYMessaging_profile">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "TradeEOYMessaging_profile"
};

(node as any).hash = "b4086373dde7c629a4bb14785a723ea3";

export default node;
